import React from "react";
import { Pencil } from "lucide-react";
import { SCOPE_LABELS } from "./api";

const KeywordChips = ({ keywords }) => (
    <div className="flex flex-wrap gap-1.5">
        {keywords.map((keyword) => (
            <span
                key={keyword.toLowerCase()}
                className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-700"
            >
                {keyword}
            </span>
        ))}
    </div>
);

const RelatedResourceCard = ({
    scopeType,
    scopeId,
    keywords = [],
    loading = false,
    error = null,
    subtitle = null,
    onEdit,
}) => (
    <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-gray-200 px-3 py-2">
            <div className="min-w-0">
                <div className="flex items-center gap-2">
                    <span className="rounded-full border border-gray-300 bg-gray-100 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-gray-600">
                        {SCOPE_LABELS[scopeType] || scopeType}
                    </span>
                    <span className="truncate font-medium text-gray-900">
                        {scopeId}
                    </span>
                </div>
                {subtitle && (
                    <p className="mt-0.5 text-xs text-gray-500">{subtitle}</p>
                )}
            </div>
            <button
                type="button"
                onClick={onEdit}
                className="inline-flex shrink-0 items-center gap-1 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-xs font-semibold text-gray-700 transition-colors hover:border-ktx-purple hover:text-ktx-purple"
            >
                <Pencil className="h-3 w-3" aria-hidden />
                Edit
            </button>
        </div>
        <div className="px-3 py-2.5">
            {loading ? (
                <p className="text-xs text-gray-500">Loading keywords...</p>
            ) : error ? (
                <p className="text-xs text-red-600">{error}</p>
            ) : keywords.length > 0 ? (
                <KeywordChips keywords={keywords} />
            ) : (
                <p className="text-xs text-gray-500">
                    No dictionary yet for this scope.
                </p>
            )}
        </div>
    </div>
);

export default RelatedResourceCard;
